<template>
  <v-card class="pa-5"  :style="{ border: '1px solid var(--primary-boarder-color)' }">
    <v-row class="mb-2 pa-5 pb-1 d-flex justify-space-between align-center">
      <span class="text-h6 font-weight-bold">Attachments</span>
      <v-btn
        v-if="hasPermission(taskData ? 'document.task_document_upload' : 'document.project_document_upload')"
        size="x-small"
        @click="openFileUploadDialog"
        color="#00B3FF"
        depressed
        class="white--text"
        >Add Attachment</v-btn
      >
    </v-row>
    <v-divider class="border-opacity-25"></v-divider>
    <v-list class="custom-list-style" v-if="project.documents && project.documents.length > 0">
      <v-list-item-group
        v-for="(attachment, index) in project.documents"
        :key="index"
        active-class="bg-white"
      >
        <v-list-item three-line>
          <v-list-item-avatar>
            <v-avatar>
              <v-img :src="fileUrl" rounded></v-img>
            </v-avatar>
          </v-list-item-avatar>
          <v-row
            class="mb-2 pa-5 pb-1 d-flex justify-space-between align-center"
          >
            <v-list-item-content>
              <v-list-item-title
                v-html="attachment.notes"
                class="font-weight-bold text-black"
              ></v-list-item-title>
              <v-list-item-subtitle
                v-html="attachment.type"
              ></v-list-item-subtitle>
            </v-list-item-content>
            <v-icon
              v-if="hasPermission(taskData ? 'document.task_document_download' : 'document.project_document_download')"
              @click="downloadAttachment(attachment.uuid)"
              color="primary"
              class="mx-2"
              >mdi-download</v-icon
            >
            <v-icon
              v-if="hasPermission(taskData ? 'document.task_document_delete' : 'document.project_document_delete')"
              @click="deleteAttachment(attachment.uuid)"
              color="red"
              class="mx-1"
              >mdi-delete</v-icon
            >
          </v-row>
        </v-list-item>
        <v-divider v-if="index < project.documents.length - 1"></v-divider>
      </v-list-item-group>
    </v-list>
    <v-row  v-else  class="d-flex align-center justify-center pb-7">
      <img class="attachment-empty-image" :src="emptyDocument"/>
    </v-row>
    <v-dialog v-model="fileUploadDialog" max-width="600px" persistent>
      <v-card class="scroll-disabled pa-5">
        <v-form ref="fileUploadForm" @submit.prevent="uploadFiles">
          <v-card-title>
            <v-row align="center" justify="space-between">
              <v-col cols="auto">
                <span class="text-h6 font-weight-bold">Upload File</span>
              </v-col>
              <v-col cols="auto">
                <v-btn
                  small
                  fab
                  depressed
                  class="mr-2 white--text"
                  color="blue"
                  sole
                  type="submit"
                >
                  <v-icon>mdi-check</v-icon>
                </v-btn>
                <v-btn
                  small
                  fab
                  depressed
                  class="mr-2 white--text"
                  color="gray"
                  sole
                  @click="close"
                >
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text class="mt-5">
            <v-file-input
              v-model="file.file"
              label="Select a file*"
              name="files"
              outlined
              dense
              accept="*"
              :rules="[(v) => !!v || 'Please select a file']"
            ></v-file-input>
            <v-row>
              <v-col>
                <v-text-field
                  v-model="file.notes"
                  label="Notes*"
                  outlined
                  dense
                  placeholder="Add notes for this file"
                  :rules="[(v) => !!v || 'Notes are required']"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-card-text>
        </v-form>
      </v-card>
    </v-dialog>
    <v-dialog v-model="confirmationDialog" max-width="400px">
      <v-card>
        <v-card-title class="text-h6 font-weight-bold"
          >Confirm Deletion</v-card-title
        >
        <v-divider></v-divider>
        <v-card-text>
          <p>Are you sure you want to delete this attachment?</p>
        </v-card-text>
        <v-card-actions>
          <v-btn @click="confirmationDialog = false" color="primary"
            >Cancel</v-btn
          >
          <v-btn @click="confirmDelete" color="red"  v-if="hasPermission(taskData ? 'document.task_document_delete' : 'document.project_document_delete')">Delete</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<style scoped>
.text-black {
  color: #000000;
}
.custom-list-style {
  height: 500px;
  overflow-y: auto;
  position: relative;
}

.attachment-empty-image {
  max-height: 490px; 
  min-height: 490px; 
}
</style>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapGetters } = createNamespacedHelpers("auth");
export default {
  data: () => ({
    defaultImage: require("@/assets/img/avatar.svg"),
    fileUrl: require("@/assets/img/file_image.svg"),
    emptyDocument: require("@/assets/img/empty_documents.svg"),
    file: {
      file: null,
      notes: null,
    },
    fileUploadDialog: false,
    confirmationDialog: false,
    attachmentToDelete: null,
  }),
  props: {
    project: Object,
    taskData: Boolean,
  },
  methods: {
    openFileUploadDialog() {
      this.fileUploadDialog = true;
    },
    uploadFiles() {
      const isValid = this.$refs.fileUploadForm.validate();

      if (isValid) {
        const fd = new FormData();
        fd.append("file", this.file.file);
        fd.append("notes", this.file.notes);
        this.$emit("documents-upload", fd);
        this.fileUploadDialog = false;
        this.reset();
      }
    },
    downloadAttachment(uuid) {
      this.$emit("documents-download", uuid);
    },
    deleteAttachment(uuid) {
      this.confirmationDialog = true;
      this.attachmentToDelete = uuid;
    },
    confirmDelete() {
      if (this.attachmentToDelete) {
        this.$emit("documents-delete", this.attachmentToDelete);
        this.confirmationDialog = false;
        this.attachmentToDelete = null;
      }
    },
    reset() {
      this.$nextTick(() => {
        if (this.$refs.fileUploadForm) {
          this.$refs.fileUploadForm.reset();
        }
      });
    },
    close() {
      (this.fileUploadDialog = false), this.reset();
    },
  },

  computed: {
    ...mapGetters({
      hasPermission: "hasPermission",
    }),
  },
};
</script>
